import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

export interface OrderCancelledDialogData {
  /** "Ticket #2610-1549 was cancelled", or "Ticket cancelled" when the number is not known. */
  title: string;
  /** "This ticket was cancelled at 9:22 PM (Replaced by the terminal's next ticket). It can't take payments." */
  message: string;
  /** The cancelled order was the POS ticket, and a fresh one replaced it. */
  newTicket: boolean;
}

/**
 * ENG-5867: the ticket on screen was cancelled somewhere else (the stale-draft sweep, another
 * device, Open Orders). Its payment screens have already closed; when it was the POS ticket, a
 * fresh one is on the POS.
 */
@Component({
  selector: 'app-order-cancelled-dialog',
  standalone: true,
  imports: [NgIf, MatDialogModule],
  template: `
    <div class="oc" role="alertdialog" aria-labelledby="oc-title" aria-describedby="oc-message">
      <h2 id="oc-title" class="oc-title">{{ data.title }}</h2>
      <p id="oc-message" class="oc-message">{{ data.message }}</p>
      <p *ngIf="data.newTicket" class="oc-next">A new ticket is ready on the POS.</p>
      <button type="button" class="oc-ok" mat-dialog-close cdkFocusInitial>OK</button>
    </div>
  `,
  styleUrls: ['./order-cancelled-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderCancelledDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: OrderCancelledDialogData) {}
}
